// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__9N061","avatar--clickable":"Avatar_avatar--clickable__tP+CV"};